// extracted by mini-css-extract-plugin
export default {"Emoji":"bci_a bik_i bik_q bik_j"};